<div class="d-flex align-items-center">
    <div ngbDropdown class="btn-group  d-flex align-items-between">

        <button class="d-flex align-items-center btn p-0">
            <div class=" me-5">
                <div class="d-flex flex-row symbol symbol-circle symbol-40px">
                <img class="user-avatar me-3"
                    src="https://ui-avatars.com/api/?background=000&color=fff&name={{token.first_name}}+{{token.last_name}}"
                    alt="">
                    <div class="d-flex flex-column justify-content-evenly">
                        <div class="fw-bolder d-flex align-items-center fs-8">
                            {{ token.first_name }} {{ token.last_name }}
                        </div>
                        <a class="fw-bold text-muted text-hover-primary fs-9 cursor-pointer">
                            {{token.user_email}}
                        </a>
                    </div>
                    <div class="symbol symbol-25px">
                    <img class="user-avatar ms-4"
                    (click)="logout()"
                    src="./assets/media/icons/duotune/arrows/arr096.svg"
                    alt="">
                   </div>
                </div>
            </div>
        </button>
    </div>
</div>